const accountUser = JSON.parse(localStorage.getItem('accountUser'));
const authCustomer = window.customer

if (!authCustomer) {
    localStorage.removeItem('accountAccessToken');
    localStorage.removeItem('persist:root');
}

if (!!accountUser) {
    const ENV = window.environment || 'dev'

    const loginUrl = 'https://facileskin.myshopify.com/api/2023-04/graphql.json';
    const SHOPIFY_CUSTOMER_API = 'https://ruhlgbuqa5.execute-api.us-east-1.amazonaws.com/default/facile-shopify-customer';
    const customerAccessToken = `
                      mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
                        customerAccessTokenCreate(input: $input) {
                          customerAccessToken {
                            accessToken
                            expiresAt
                          }
                          customerUserErrors {
                            code
                            field
                            message
                          }
                        }
                      }
                    `;

    const bookingLogin = function (url, query, input) {
        return fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': '56052901986a2f9175acb93e49186303',
            },
            body: JSON.stringify({
                query,
                variables: {
                    input,
                },
            }),
        }).then((res) => res.json());
    };

    const updateShopifyUser = async function (url, body, query) {
        query.env = ENV
        url = new URL(url);
        url.search = new URLSearchParams(query).toString();

        return await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        }).then((res) => res.json());
    };

    bookingLogin(loginUrl, customerAccessToken, {
        email: accountUser.email,
        password: accountUser.password,
    }).then((res) => {
        if (!res.data.customerAccessTokenCreate.customerAccessToken) {
            localStorage.removeItem('accountUser');
            return;
        }

        const accessToken = res.data.customerAccessTokenCreate.customerAccessToken.accessToken;

        if (accountUser.gender === 'Gender*') {
            accountUser.gender = '';
        }
        updateShopifyUser(
            SHOPIFY_CUSTOMER_API,
            {
                metafields: [
                    {
                        namespace: 'custom_fields',
                        key: 'gender',
                        value: accountUser.gender,
                        type: 'single_line_text_field',
                    },
                    {
                        namespace: 'custom_fields',
                        key: 'phone',
                        value: accountUser.phone,
                        type: 'single_line_text_field',
                    },
                    {
                        namespace: 'custom_fields',
                        key: 'dob',
                        value: accountUser.dob,
                        type: 'single_line_text_field',
                    }
                ],
            },
            { type: 'update', customerAccessToken: accessToken }
        ).then(() => {
            localStorage.setItem('accountAccessToken', accessToken);
            localStorage.removeItem('accountUser');
            localStorage.setItem(
                'persist:root',
                JSON.stringify({
                    accessToken: accessToken,
                    _persist: { version: -1, rehydrated: true },
                })
            );
        }).catch((er) => {
            console.log(er);
        });
    }).catch((err) => console.log(err));
}
